module.exports = __webpack_public_path__ + "img/四川大学华西第二医院.35a7832b.png";